export const queryNames = {
  search: 'search',
  asset: 'asset',
  assetRelationships: 'assetRelationships',
  assetVersions: 'assetVersions',
  assetVision: 'assetVision',
  collection: 'collection',
  schema: 'schema',
  schemas: 'schemas',
  schemaPresets: 'schemaPresets',
  settings: 'settings',
  userManagement: 'userManagement',
  user: 'user',
  groupMembers: 'groupMembers',
  activate: 'activate',
  notification: 'notification',
  substitution: 'substitution',
  queueStats: 'queueStats',
  share: 'share',
  shareTemplate: 'shareTemplate',
  onboardingProgress: 'onboardingProgress',
  chatSessions: 'chatSessions',
  chatSuggestions: 'chatSuggestions',
  libraryCount: 'libraryCount',
  aiSettings: 'aiSettings',
  aiBudget: 'aiBudget',
  userAiBudget: 'userAiBudget',
  aiCredits: 'aiCredits',
  aiCreditLedger: 'aiCreditLedger',
  aiUsageBreakdown: 'aiUsageBreakdown',
  schedules: 'schedules',
  schedule: 'schedule',
  scheduleRuns: 'scheduleRuns',
  scheduleRunSession: 'scheduleRunSession',
  scheduleCredentials: 'scheduleCredentials',
  connectedApps: 'connectedApps',
  agentToolCalls: 'agentToolCalls',
  agentToolCallSummary: 'agentToolCallSummary',
  notificationSettings: 'notificationSettings',
  subscription: 'subscription',
  writeStatus: 'writeStatus',
  plans: 'plans',
  topupPacks: 'topupPacks',
  schemaAddon: 'schemaAddon',
  featureTrials: 'featureTrials',
  planLimits: 'planLimits',
  aiRates: 'aiRates',
  invoices: 'invoices',
  cdnPopularAssets: 'cdnPopularAssets',
  cdnAudience: 'cdnAudience',
  cdnTimeseries: 'cdnTimeseries',
  cdnCachePerformance: 'cdnCachePerformance',
  cdnPopularTransforms: 'cdnPopularTransforms',
  cdnTransformCoverage: 'cdnTransformCoverage',
  cdnCampaigns: 'cdnCampaigns',
  cdnCampaignDetail: 'cdnCampaignDetail',
  cdnChannels: 'cdnChannels',
  cdnChannelDetail: 'cdnChannelDetail',
  cdnDistinctValues: 'cdnDistinctValues',
  analyticsDestinations: 'analyticsDestinations',
  migrationOverview: 'migrationOverview',
  migrationCopy: 'migrationCopy',
  uploadLink: 'uploadLink',
};
